import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-healthcheck',
  templateUrl: './healthcheck.component.html',
})
export class HealthcheckComponent {
  constructor() {}
}
